export const MARKETING_ROUTES = {
  home: '/',
  discover: '/decouvrir',
  analyze: '/analyser',
  decide: '/decider-suivre',
} as const

export const MARKETING_LEGAL_LINKS = {
  terms: 'https://methode-trident.com/cgv',
  privacy: 'https://methode-trident.com/politique-de-confidentialite',
  legal: 'https://methode-trident.com/mentions-legales',
} as const

export const MARKETING_CONTACT_EMAIL = 'contact@methode-trident.com'

export const MARKETING_NAVIGATION = [
  { label: 'Découvrir', href: MARKETING_ROUTES.discover },
  { label: 'Analyser', href: MARKETING_ROUTES.analyze },
  { label: 'Décider & Suivre', href: MARKETING_ROUTES.decide },
] as const

export const MARKETING_PRICE = {
  amount: 397,
  currency: 'EUR',
  label: '397 € par an',
} as const

export const MARKETING_SCREENSHOTS = {
  purchase: '/marketing/screenshots/achat-recommandation.webp',
  screener: '/marketing/screenshots/screener-filtres.webp',
  podium: '/marketing/screenshots/podium.webp',
  company: '/marketing/screenshots/analyse-entreprise.webp',
  valuation: '/marketing/screenshots/t-graph.webp',
  comparison: '/marketing/screenshots/comparaison.webp',
  purchaseAdvanced: '/marketing/screenshots/achat-avance.webp',
  performance: '/marketing/screenshots/performance.webp',
  progression: '/marketing/screenshots/progression.webp',
} as const
